module.exports = __webpack_public_path__ + "img/service-icon4.191d0daf.jpg";